import React from "react";
import ProductFieldDropdown from "../ProductFieldDropdown";
import { Button, Icon, Popup } from "semantic-ui-react";

const Relations = ({ context, translate }) => (
    <div>
        {context.isRequiredField('group_id') && <ProductFieldDropdown name='group_id'
                              title={translate("tools.fields.group")}
                              search selection
                              error={!!(typeof context.state.errors !== "undefined" && (context.state.errors.group_id))}
                              options={context.props.productGroups
                                  .map((group) => ({
                                      key: group.id,
                                      text: group.name,
                                      value: group.id
                                  }))}
                              context={context}
                              required
        />}

        {context.isRequiredField('category_id') && 
        <Popup trigger={
            <ProductFieldDropdown name='category_id'
                              title={translate("tools.fields.category")}
                              search selection
                              error={!!(typeof context.state.errors !== "undefined" && (context.state.errors.category_id))}
                              options={context.props.productCategories
                                  .map((category) => ({
                                      key: category.id,
                                      text: category.name,
                                      value: category.id
                                  }))}
                              context={context}
                              required
            />
        }
               on='focus'
               header={translate("tools.fields.category")}
               content='Die Artikelkategorie wird für Spirituosen verwendet um eine genauere Aufteilung in die verschiedenen Unterkategorien wie Gin, Vodka, etc. zu erreichen'
        />}

        {context.isRequiredField('supplier_id') && <ProductFieldDropdown name='supplier_id'
                              title={translate("tools.fields.supplier")}
                              search selection
                              error={!!(typeof context.state.errors !== "undefined" && (context.state.errors.supplier_id))}
                              options={context.props.suppliers
                                  .filter((supplier) => {
                                      return supplier.prefix !== null;
                                  })
                                  .map((supplier) => {
                                      return {
                                          key: supplier.id,
                                          text: supplier.name + " (" + supplier.supplier_id + ")",
                                          value: supplier.id
                                      };
                                  })}
                              context={context}
                              required
        />}

        {context.isRequiredField('country_id') && <ProductFieldDropdown name='country_id'
                              title={translate("tools.fields.country")}
                              search selection
                              error={!!(typeof context.state.errors !== "undefined" && (context.state.errors.country_id))}
                              options={context.props.countries
                                  .map((country) => ({
                                      key: country.id,
                                      text: country.name + " (" + country.country_id + ")",
                                      value: country.id
                                  }))}
                              context={context}
                              required
        />}

        {context.isRequiredField('vatrate_id') && <ProductFieldDropdown name='vatrate_id'
                              title={translate("tools.fields.vatrate")}
                              error={!!(typeof context.state.errors !== "undefined" && (context.state.errors.vatrate_id))}

                              search selection
                              options={[
                                  {
                                      key: 42,
                                      text: "7.7%",
                                      value: 42
                                  },
                                  {
                                      key: 40,
                                      text: "2.5%",
                                      value: 40
                                  }, {
                                      key: 39,
                                      text: "Steuerfrei",
                                      value: 39
                                  }
                              ]}
                              context={context}
                              required
        />}

        {context.isRequiredField('brand_id') && context.props.brands &&
        <div>
            <ProductFieldDropdown name='brand_id'
                                  title={translate("tools.fields.brand")}
                                  search selection
                                  options={context.props.brands
                                      .map((brand) => ({
                                          key: brand.id,
                                          text: brand.name + " (" + brand.brandID + ")",
                                          value: brand.id
                                      }))}
                                  context={context}/>
            {context.state.product.brand_id !== 0 &&
            <Button type={"button"} icon labelPosition='left'
                    onClick={() => {
                        context.resetProductField("brand_id");
                    }}
            >
                <Icon name='repeat'/>
                {translate("general.reset")}
            </Button>
            }

        </div>
        }
    </div>
);

export default Relations;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/Relations/index.js